<template lang="pug">
  .card
    header.card-header
      p.card-header-title
        slot(name="title")
          | Adjunta una imagen o pdf
      a.card-header-icon
        span.icon
          i.fa.fa-file-image-o
    .card-content
      .content
        form.upload-container.w-64(enctype="multipart/form-data", @submit.prevent="UploadsMultiFiles")
          p.has-text-left
            span
              slot(name="explanation")
                | Adjunta una imagen o pdf
          .dropzone(
            id="dropzone"
            @click='select'
          )
            transition(name="fade-quick")
              .overlay(v-show="$upload.dropzone(name).active")
                span Suelta el archivo para cargarlo
            //- .upload-progress(v-if='$upload.meta(name).status == "sending"')
            //-   span {{$upload.meta(name).percentComplete}}%
            span.icon.is-large
              i.fa.fa-cloud-upload
            span.margin-bottom-10 Arrastra el archivo que desees cargar o dale click al recuadro para buscar en tus archivos

          .error(v-if="$upload.errors(name).length > 0")
            | {{ $upload.errors(name)[0].msg }}

          transition(name="fade")
            div(v-if="files.length > 0")
              .contenedor-files-prev.overflow-y-pretty.mb-10.text-left
                div.display-flex.p-2(v-for="(o, index) in files", :key="index")
                  span.file-name.mb-4.text-purple-500.font-bold.flex-1 {{ o.name }}
                  span.icon.color-red.margin-left-5.cursor-pointer(@click="removeFile(index)", tittle="Borrar adjunto")
                    i.fa.fa-trash
              .buttons-container
                template
                  button.button.flex-1.margin-left-5.is-primary(
                    type="submit"
                    :disabled="isUploading"
                  )
                    span(v-if="isUploading") Adjuntando...
                    span(v-else) Adjuntar archivos

    footer.card-footer
      a.card-footer-item(
        @click="close"
      ) Cancelar
</template>

<script>
  import { apiUploadWithParams, notify } from '../util/general'

  export default {
    name: 'upload_component',
    props: ['url', 'name', 'isSaving', 'isSaved', 'observations', 'folder', 'onlyPdf'],
    data () {
      return {
        files        : [],
        filesUploads : [],
        isUploading  : false,
        apiRoute     : process.env.API_ROUTE,
        extensions   : ['pdf']
      }
    },
    computed: {
      _meta () {
        let vm = this
        return this.$upload.meta(vm.name);
      },
      _file () {
        let vm = this
        return vm.$upload.file(vm.name);
      }
    },
    mounted () {
      var vm = this
      vm.create()
      vm.$forceUpdate()
    },
    beforeDestroy () {
      let vm = this
      vm.$upload.off(vm.name);
    },
    methods: {
      create () {
        let vm = this
        if (vm.onlyPdf) {
          vm.extensions = ['pdf']
        }
        vm.$upload.on(vm.name, {
          extensions     : vm.extensions,
          maxSizePerFile : 1024 * 1024 * 5,
          dropzoneId     : 'dropzone',
          startOnSelect  : false,
          multiple       : true,
          http: (data) => {
          },
          onSelect: (files, res) => {
            let hasExtensionError = false
            for (let i = 0; i < files.length; i++) {
              let file = files[i]
              let extension = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length)
              if (!vm.extensions.includes(extension)) {
                hasExtensionError = true
              } else {
                vm.files.push(files[i])
              }
            }
            if (hasExtensionError) {
              vm.$upload.reset(vm.name)
              vm.files = []
              notify(vm, 'error', 'Error', `Solo se permiten archivos ${vm.extensions.join(', ')}`)
            }
          },
          onProgress (file, res) {
          },
          onSuccess: (file, res) => {
            this.file.push(res.data.data)
          },
          onError: (file, res) => {
          },
          onEnd (files, res) {
          }
        })
      },
      select () {
        let vm = this
        vm.$upload.select(vm.name);
      },
      start () {
        let vm = this
        vm.$upload.start(vm.name);
      },
      reset () {
        let vm = this
        this.$upload.reset(vm.name);
      },
      limpiar () {
        let vm = this
        this.$upload.reset(vm.name)
      },
      update () {
        var vm = this
        vm.$upload.reset(vm.name)
      },
      uploadFile (file, callback) {
        var vm = this

        if (vm.$upload.errors(vm.name).length > 0) {
          callback(new Error('Por favor corrija los errores del archivo adjunto'))
          return
        }

        var fd = new FormData()
        fd.append('file', file)
        var params = {
          carpeta: vm.folder,
          usuario: localStorage.getItem('usuario')
        }

        apiUploadWithParams(vm, `/upload`, fd, params, res => {
          callback(null, res)
        }, err => {
          console.error(err)
          callback(err)
        })
      },
      fileUploadRecursivo (index, callback) {
        var vm = this
        vm.uploadFile(vm.files[index], async (err, response) => {
          if (err) {
            callback(err)
          } else {
            vm.filesUploads.push(response)
            index++
            if (index === vm.files.length) callback(null)
            else vm.fileUploadRecursivo(index, callback)
          }
        })
      },
      UploadsMultiFiles () {
        var vm         = this
        vm.isUploading = true

        vm.fileUploadRecursivo(0, err => {
          if (err) {
            notify(vm, 'error', 'Error', err.message)
            vm.isUploading = false
            return
          }

          notify(vm, 'success', 'Exito', 'Se adjuntaron los archivos correctamente')
          vm.$emit('save', vm.filesUploads)
          vm.files = []
          vm.filesUploads = []
          vm.isUploading = false
        })
      },
      close () {
        var vm = this
        vm.$emit('close')
      },
      removeFile (index) {
        var vm = this
        vm.files.splice(index, 1)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  .download-container
    padding 13px 10px 0px 10px

  .upload-container
    padding 13px 10px 0px 10px
    .dropzone
      width 100%
      height fit content
      border: 4px dashed;
      position relative
      border-radius 10px
      border-color #00d1b2;
      margin 10px 0px
      display flex
      flex-direction column
      justify-content center
      align-items center
      cursor pointer
      padding: 10px;

      .overlay
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        background-color rgba(10,10,10,.3)
        display flex
        justify-content center
        align-items center
        color #fff
        font-size 28px

      .upload-progress
        position absolute
        top 0
        right 0

      .icon
        display: block;
        margin-top: 10px;

    .uploaded-file
      display flex
      flex-direction column
      justify-content center
      align-items center
      button
        margin-top 5px


    .error
      color red

    .observations
      margin-top 10px
      display flex
      flex-direction column
      align-items center
      border 1px solid red
      padding 10px
      background-color #fde0e0
      p
        font-size 20px
        margin-bottom 0
      ul
        list-style-type none
        text-align left
        font-weight bold
        .error
          color red
        .warning
          color #4831ff

.contenedor-files-prev
  max-height: 323px;
  font-size 11px


</style>



// WEBPACK FOOTER //
// c_upload_multi_files.vue?0717e10a